export const APPOINTMENT_ID_LENGTH = 32;

export const APPOINTMENT_MESSAGE_SENDER_ADMIN = 1;
export const APPOINTMENT_MESSAGE_SENDER_PATIENT = 2;
export const APPOINTMENT_MESSAGE_SENDER_DOCTOR = 3;

export const APPOINTMENT_MESSAGE_SENDER = {
  admin: APPOINTMENT_MESSAGE_SENDER_ADMIN,
  patient: APPOINTMENT_MESSAGE_SENDER_PATIENT,
  doctor: APPOINTMENT_MESSAGE_SENDER_DOCTOR
} as const;
